import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Hint from 'components/Hint';
import PlaylistDropdown from 'components/ParentPlaylistDropdown';
var ParentPlaylistsInfo = function ParentPlaylistsInfo(_ref) {
  var parentPlaylists = _ref.parentPlaylists,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'asset' : _ref$type;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var parentPlaylistCount = parentPlaylists.length;
  var key = type === 'playlist' ? 'parent_playlist_playlist_panel_hint_title' : 'parent_playlist_asset_panel_hint_title';
  return /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: key,
    count: parentPlaylistCount
  }, "This ".concat(type, " is in"), ' ', /*#__PURE__*/React.createElement(PlaylistDropdown, {
    playlists: parentPlaylists
  }, "count playlists")));
};
export default ParentPlaylistsInfo;